<template>
  <layout-pondlogs class="v2-dasboard">
    <template slot="pondlogs-default-layout-main">
      <portal to="destination">
        <div class="portal-container">
          <el-tabs
            :value="computedComponentName"
            @tab-click="handleDashboardTabClick"
          >
            <el-tab-pane
              v-for="(item, key) in filterMenuItemsByPermissions"
              :name="item.name"
              :key="key"
            >
              <span class="tab-header" slot="label">
                <span class="tab-label__content-dashboard">
                  {{ item.label }}
                </span>
              </span>
            </el-tab-pane>
          </el-tabs>
        </div>
      </portal>
      <component :is="computedComponentName"></component>
    </template>
  </layout-pondlogs>
</template>

<script>
const dashboardTab = () =>
  import(
    /* webpackChunkName: "dashboardTab" */ "@/components/v2Dashboard/dashboard/dashboardTab"
  );
const pondInfoTab = () =>
  import(
    /* webpackChunkName: "pondInfoTab" */ "@/components/v2Dashboard/pond-info/pondInfoTab"
  );
const pondAlertsTab = () =>
  import(
    /* webpackChunkName: "pondAlertsTab" */ "@/components/v2Dashboard/pond-alerts/pondAlertsTab"
  );
import { mapGetters } from "vuex";
import pondInfoMod from "@/store/components/pondInfo";
import dashboardMod from "@/store/components/dashboard";
import alertsInfoMod from "@/store/components/alertsInfo";

import {
  permissionsToStringMap as permissions,
  isValidTabName,
  getFirstTabBasedOnPermissions
} from "@/middleware/pageAccessManager";
const tabToPermission = {
  dashboardTab: {
    name: "dashboardTab",
    keyToValidateAccess: "PERMISSIONS",
    PERMISSIONS: [permissions.MANAGE_OVERVIEW]
  },
  pondInfoTab: {
    name: "pondInfoTab",
    keyToValidateAccess: "PERMISSIONS",
    PERMISSIONS: [
      permissions.MANAGE_OVERVIEW,
      permissions.MANAGE_CULTURE,
      permissions.MANAGE_ABW,
      permissions.MANAGE_HARVEST
    ]
  },
  pondAlertsTab: {
    name: "pondAlertsTab",
    keyToValidateAccess: "PERMISSIONS",
    PERMISSIONS: [
      permissions.MANAGE_OVERVIEW,
      permissions.MANAGE_CULTURE,
      permissions.MANAGE_DEVICES
    ]
  }
};

const storeModules = {
  dashboardTab: {
    name: "dashboard",
    module: dashboardMod
  },
  pondInfoTab: {
    name: "pondInfo",
    module: pondInfoMod
  },
  alertsInfoTab: {
    name: "alertsInfo",
    module: alertsInfoMod
  }
};

export default {
  name: "DashboardTab",
  components: {
    dashboardTab,
    pondInfoTab,
    pondAlertsTab
  },
  computed: {
    ...mapGetters("user", {
      getViewPermissions: "getViewPermissions",
      getCurrUserLocation: "getCurrUserLocation",
      getViewPermissions: "getViewPermissions"
    }),
    menuItems: function() {
      return {
        dashboardTab: {
          label: this.$t("Comn_dashboard"),
          ...tabToPermission.dashboardTab
        },
        pondInfoTab: {
          label: `${this.$t("Comn_ponds")} Info`,
          ...tabToPermission.pondInfoTab
        },
        pondAlertsTab: {
          label: `${this.$t("Comn_ponds")} ${this.$t("Comn_alerts")}`,
          ...tabToPermission.pondAlertsTab
        }
      };
    },
    filterMenuItemsByPermissions: function() {
      return this.itemsUserCanView(this.menuItems);
    },
    computedComponentName: function() {
      return this.$route.query.tab;
    }
  },
  beforeCreate() {
    for (const key in storeModules) {
      if (!this.$store.hasModule(storeModules[key].name)) {
        this.$store.registerModule(
          storeModules[key].name,
          this.$lodash.cloneDeep(storeModules[key].module)
        );
      }
    }
    const viewPermissions = this.$store.getters["user/getViewPermissions"];
    const userType = this.$store.getters["user/getCurrUserType"];
    const tabName = this.$route.query.tab;
    console.log(tabName);
    if (!isValidTabName(tabName, tabToPermission, viewPermissions, userType)) {
      console.log(
        getFirstTabBasedOnPermissions(
          tabToPermission,
          viewPermissions,
          userType
        )
      );
      this.$router.push({
        path: "/user/dashboard",
        query: {
          tab: getFirstTabBasedOnPermissions(
            tabToPermission,
            viewPermissions,
            userType
          )
        }
      });
    }
  },
  beforeRouteLeave(to, from, next) {
    for (const key in storeModules) {
      if (this.$store.hasModule(storeModules[key].name)) {
        this.$store.unregisterModule(storeModules[key].name);
      }
    }
    next();
  },
  methods: {
    handleDashboardTabClick(tab) {
      this.$router.push({
        path: "/user/dashboard",
        query: { tab: tab.paneName }
      });
    }
  }
};
</script>

<style lang="scss">
@import "../../styles/mixins.scss";
</style>
